import { Skeleton, styled, useTheme } from '@mui/material';
import { ControlContainer, Count } from './styled.ts';

const SkeletonContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
  borderRadius: theme.spacing(0.5),
  paddingBottom: '45%',
  [theme.breakpoints.between('md', 'lg')]: {
    paddingBottom: '50%',
  },
  [theme.breakpoints.down('md')]: {
    paddingBottom: '56%',
  },
  position: 'relative',
  width: '100%',
}));

export const ImageCarouselSkeleton = () => {
  const theme = useTheme();

  return (
    <div>
      <SkeletonContainer>
        <ControlContainer
          sx={{
            height: '100%',
            left: 0,
            paddingLeft: theme.spacing(1),
            position: 'absolute',
            top: 0,
            zIndex: 1,
          }}
        >
          <Skeleton height={56} variant="circular" width={56} />
        </ControlContainer>
        <ControlContainer
          sx={{
            height: '100%',
            paddingRight: theme.spacing(1),
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: 1,
          }}
        >
          <Skeleton height={56} variant="circular" width={56} />
        </ControlContainer>
      </SkeletonContainer>
      <Count>
        <Skeleton sx={{ fontSize: '1rem' }} variant="text" width={30} />
      </Count>
    </div>
  );
};
